module.exports = __webpack_public_path__ + "img/2.c4f88454.png";